import { AxelType } from '../type';
import { assignWithDefined } from '../util';
import numberFormat from './number.format';

const DEFAULT_PERCENTAGE_PRECISION = 0;

export default function percentage(localeSettings = null, opts: any = {}): (data: AxelType) => any {
  const defaults = {
    precision: DEFAULT_PERCENTAGE_PRECISION,
    type: '%',
    symbol: false,
  };

  return numberFormat.call(null, localeSettings, assignWithDefined({}, defaults, opts));
}
